module.exports = __webpack_public_path__ + "static/images/components/ButtonInbox/images/button-inbox-new-message.e7be4ed2.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonInbox/images/button-inbox-new-message.png
// module id = 2569
// module chunks = 11